import { useTranslation } from 'react-i18next';
import { Badge } from '@mantine/core';
import { signatureStateView } from '@/lib/dealStatus';
import type { DocumentSignatureInfo, SignatureRole } from '@/types/deals';

interface SignatureBadgeProps {
  readonly role: SignatureRole;
  readonly info: DocumentSignatureInfo | undefined;
}

// Бейдж подписи одной роли на документе. NOT_REQUIRED/отсутствие → ничего (роль не подписывает).
// Для DONE различаем ЭДО (signatureType=EDO) и ручную ПЭП (BES).
export default function SignatureBadge({ role, info }: SignatureBadgeProps) {
  const { t } = useTranslation();
  const view = signatureStateView(info?.state);
  if (!view || !info) {
    return null;
  }
  const roleLabel = t(`app.deals.role.${role}`);
  let stateLabel = t(view.labelKey);
  if (info.state === 'DONE') {
    stateLabel = info.signatureType === 'BES' ? t('app.deals.sign.doneBes') : t('app.deals.sign.doneEdo');
  }
  return (
    <Badge variant="light" color={view.color} tt="none" fw={500} radius="sm" size="sm">
      {roleLabel}: {stateLabel}
    </Badge>
  );
}
